import { Formik, Form } from "formik";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Images } from "../../../../config/images";
import CustomInput from "../../../common/CustomInput";
import "./TeacherForgotPassword.css";
import { useTenantForgotPassword } from "../../../../hooks/tenant/useTenantForgotPassword";
import { Button } from "react-bootstrap";
import { getSubdomain } from "../../../../utils/subdomian";
import { handleSmartBack } from "../../../../utils/navigationHelper";

const TeacherForgotPassword = () => {
  const navigate = useNavigate();
  const inputRef = useRef(null);
  const [email, setEmail] = useState("");

  const { loading, error, forgotPassword } = useTenantForgotPassword();

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const initialValues = {
    email: "",
  };
  const subdomain = getSubdomain();
  console.log(subdomain);

  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const handleLogin = async (values) => {
    await forgotPassword({
      email: values.email,
      subdomain: subdomain,
      onSuccess: () => {
        setEmail(values.email);
      },
    });
  };

  return (
    <section className="tenant-login-wrapper">
      <div className="tenant-login-card">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleLogin}
        >
          {({ isSubmitting, submitForm }) => (
            <>
              {/* Logo */}
              <div className="tenant-login-logo">
                <img
                  src={Images.Logo}
                  alt="logo"
                  onClick={() => navigate("/")}
                />
                {!email && (
                  <div>
                    <p className="tenant-login-title">Forgot Password?</p>
                    <p className="tenant-text">
                      We'll send you reset instructions.{" "}
                    </p>
                  </div>
                )}
              </div>

              {/* Success Screen or Form */}
              {email ? (
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <p className="tenant-login-title">Check your email.</p>
                  <div className="tenant-text">
                    we sent a password reset link to
                  </div>
                  <div className="resend-email">{email}</div>

                  <div className="tenant-text pt-4">
                    Didn't receive the email?
                    <span
                      className="resend-btn-text"
                      onClick={() => {
                        setEmail("");
                      }}
                    >
                      Resend
                    </span>
                  </div>
                </div>
              ) : (
                <Form className="d-flex flex-column gap-4">
                  <CustomInput
                    label="Email"
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    className="custom-primary-input"
                    layout="stacked"
                    ref={inputRef}
                  />
                  <div>
                    {/* API Error */}
                    {error && (
                      <div className="custom-error text-center pb-3">
                        {error}
                      </div>
                    )}

                    {/* Submit Button */}
                    <Button
                      type="submit"
                      className="custom-primary-button"
                      disabled={loading || isSubmitting}
                    >
                      {loading ? "Sending..." : "Reset Password"}
                    </Button>
                  </div>
                </Form>
              )}

              <div className="go-back-container">
                <div className="go-back-btn" onClick={() => handleSmartBack(navigate, "/login")}>
                  <i className="bi bi-arrow-left icon-shadow"></i>
                  <div className="pl-4"> Back to Login</div>
                </div>
              </div>
            </>
          )}
        </Formik>
      </div>
    </section>
  );
};

export default TeacherForgotPassword;
